import { createVNode, render } from 'vue';
import checkConfetti from '~/assets/json/lottie/confetti.json';

export default async() => {
  const { Vue3Lottie } = await import('vue3-lottie');

  const wrapper = document.createElement('div');
  wrapper.classList.add('fixed', 'top-0', 'left-0', 'w-full', 'h-full', 'flex', 'items-end', 'z-900', 'pointer-events-none');

  for (let i = 0; i < 4; i++) {
    const div = document.createElement('div');
    div.classList.add('w-1/4', 'h-screen');

    const component = createVNode(Vue3Lottie, {
      loop: false,
      autoplay: true,
      animationData: checkConfetti,
      height: 'auto',
      class: 'mx-0 w-full h-screen [&_svg]:align-bottom',
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });

    render(component, div);

    wrapper.appendChild(div);
  }

  document.body.appendChild(wrapper);

  setTimeout(() => {
    wrapper.remove();
  }, 3.8 * 1000);
};
